import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { articles, type LText } from "@/mocks/articles";

export default function GuideSection() {
  const { t, i18n } = useTranslation();
  const lang = (i18n.language || "en").split("-")[0] as keyof LText;
  const text = (o: LText) => o[lang] || o.en;

  return (
    <section className="px-4 md:px-6 py-12 md:py-16 bg-secondary-50">
      <div className="text-center max-w-2xl mx-auto">
        <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">{t("home.guideTitle")}</h2>
        <p className="mt-3 text-foreground-600">{t("home.guideSubtitle")}</p>
      </div>

      <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
        {articles.map((a) => (
          <Link
            key={a.slug}
            to={`/article/${a.slug}`}
            className="group flex flex-col rounded-xl border border-background-200 bg-background-50 overflow-hidden hover:-translate-y-1 transition-all cursor-pointer"
          >
            <div className="relative h-40 overflow-hidden">
              <img
                src={a.image}
                alt={text(a.title)}
                className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
              />
            </div>
            <div className="p-4 flex flex-col flex-1">
              <div className="flex items-center gap-2 text-xs font-semibold flex-wrap">
                <span className="rounded-full bg-accent-100 text-accent-600 px-3 py-1">{text(a.category)}</span>
                <span className="text-foreground-400 whitespace-nowrap">{t("home.guideTime")}</span>
              </div>
              <h3 className="mt-3 font-heading text-base md:text-lg font-bold text-foreground-950 group-hover:text-primary-600 transition-colors leading-snug">
                {text(a.title)}
              </h3>
              <p className="mt-2 text-sm text-foreground-600">{text(a.excerpt)}</p>
              <span className="mt-4 inline-flex items-center gap-2 text-sm font-semibold text-primary-600">
                {t("home.guideRead")}
                <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
              </span>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}